var map = {
	"./biogas-en-electriciteit.svg": 750,
	"./bosbescherming.svg": 3082,
	"./efficiënte-kookstellen.svg": 8342,
	"./nieuwe-bomen.svg": 6791,
	"./placeholder.svg": 2672,
	"./veen.svg": 8583,
	"./windenergie.svg": 7128,
	"./zonne-energie.svg": 8269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;